import React from 'react';
import {object, func, bool} from 'prop-types';
import BasicModal from '../common/BasicModal';
import ErrorDisplay from '../common/ErrorDisplay';
import {basicForm} from 'utils/helpers';
import config from './createPrizeFormConfig';

const CreatePrizeForm = basicForm(config);

const CreatePrizeFormModal = props => (
  <BasicModal
    header='Create a new prize'
    specialType='primary-modal db-create-break-modal fadeInUp animResponse'
    dimmer='inverted'
    modalSize="small"
    actions={[
      {
        label: 'Cancel',
        action: props.handleClose,
        isDisabled: false,
        displayType: 'menu-item'
      },
      {
        label: 'Create a new prize',
        action: props.submit,
        isDisabled: props.hasErrors || !props.formData.title,
        displayType: 'button',
        primaryCheck: true
      }
    ]}
    open={props.modalOpen}
    onClose={props.handleClose}>
    <CreatePrizeForm
      onValueChanged={props.onValueChanged}
      onValidationError={props.onValidationError}
      errors={props.errors}
      data={props.formData} />
    <ErrorDisplay error={props.creationError}/>
  </BasicModal>
);

CreatePrizeFormModal.propTypes = {
  formData: object.isRequired,
  submit: func.isRequired,
  onValueChanged: func.isRequired,
  onValidationError: func,
  hasErrors: bool,

  handleClose: func.isRequired,
  modalOpen: bool.isRequired
};

export default CreatePrizeFormModal;



// WEBPACK FOOTER //
// ./public/components/prizes/CreatePrizeFormModal.jsx